/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-horizontal-14[_ngcontent-%COMP%]{padding:0 14px}.title[_ngcontent-%COMP%]{color:#458da8;font-weight:700}.padding-10[_ngcontent-%COMP%]{padding:10px}.btn-ok[_ngcontent-%COMP%]{position:fixed;bottom:5px;right:30px;width:80px;height:30px;border-radius:0}.description[_ngcontent-%COMP%]{font-size:14px;white-space:pre-wrap;text-align:left;overflow-y:auto}.close-icon[_ngcontent-%COMP%]{position:fixed;right:10px;color:#000;font-size:25px;font-weight:700}"];
export { styles as styles };
